<script lang="ts">
  import type { Snippet } from 'svelte';
  import Sidebar from './Sidebar.svelte';
  import Topbar from './Topbar.svelte';

  const { onLogout, children }: { onLogout: () => void; children: Snippet } = $props();

  // Drawer state lives here (the shared parent) rather than in Sidebar
  // itself — same shape as toyamacrm's Header.svelte `mobileNavOpen`, just
  // split across two components since genba's shell already was.
  let mobileNavOpen = $state(false);
</script>

<div class="shell">
  {#if mobileNavOpen}
    <button
      type="button"
      class="sidebar-backdrop"
      aria-label="Close navigation"
      onclick={() => (mobileNavOpen = false)}
    ></button>
  {/if}
  <Sidebar {onLogout} open={mobileNavOpen} onNavigate={() => (mobileNavOpen = false)} />
  <div class="main">
    <Topbar onMenu={() => (mobileNavOpen = true)} />
    <div class="content">
      <div class="wrap">
        {@render children()}
      </div>
    </div>
  </div>
</div>
